'use client'

import clsx from 'clsx'

import { ModelsNews } from '@/api/generated-api'

import { getNewsMediaBlockBySlot } from '../../../utils/newsMediaBlocks'
import { parseNewsContent } from '../../../utils/parseNewsContent'
import S from './NewsArticleBody.module.scss'
import NewsMediaBlock from './NewsMediaBlock'

type NewsArticleBodyProps = {
  news: ModelsNews
}

const NewsArticleBody = ({ news }: NewsArticleBodyProps) => {
  const segments = parseNewsContent(news.content)
  const title = news.title || ''
  const glowByIndex = (() => {
    let hasSeenMedia = false
    let htmlAfterMediaIndex = 0
    const result = new Map<number, string | undefined>()

    for (const [index, segment] of segments.entries()) {
      if (segment.type === 'media') {
        hasSeenMedia = true
        continue
      }

      if (!hasSeenMedia) {
        continue
      }

      result.set(
        index,
        htmlAfterMediaIndex === 0
          ? S.richTextGlowEnd
          : htmlAfterMediaIndex === 1
          ? S.richTextGlowStart
          : undefined
      )
      htmlAfterMediaIndex += 1
    }

    return result
  })()

  if (segments.length === 0) {
    return null
  }

  return (
    <article className={S.article}>
      {segments.map((segment, index) => {
        if (segment.type === 'html') {
          return (
            <div
              key={`html-${index}`}
              className={clsx(S.richText, glowByIndex.get(index))}
              dangerouslySetInnerHTML={{ __html: segment.html }}
            />
          )
        }

        return (
          <NewsMediaBlock
            key={`media-${segment.slot}-${index}`}
            block={getNewsMediaBlockBySlot(news.media_blocks, segment.slot)}
            title={title}
          />
        )
      })}
    </article>
  )
}

export default NewsArticleBody
